"use strict";

function numberOrZero(number) {
  return Number(number) || 0;
}

module.exports = {
  numberOrZero: numberOrZero
};